import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import validation from "react-validation-mixin";
import strategy from "joi-validation-strategy";
import Joi from "joi";
import NumericInput from "react-numeric-input";
import { StatesList } from "../../../Helper/StatesList";
import InputMask from "react-input-mask";
import * as message from "../../../config/CommonMessages";

class InviteCompanyInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.getUserData().companyInformation.name,
      website: props.getUserData().companyInformation.website,
      address: props.getUserData().companyInformation.address,
      zipcode: props.getUserData().companyInformation.zipcode,
      city: props.getUserData().companyInformation.city,
      state: props.getUserData().companyInformation.state,
      phoneNumber: props.getUserData().companyInformation.phoneNumber,
      // faxNumber: props.getUserData().companyInformation.faxNumber,
      // typeOfBusiness: props.getUserData().companyInformation.typeOfBusiness,
      // companySize: props.getUserData().companyInformation.companySize,
      // agentPercent: props.getUserData().agentPercent,
      // brokerPercent: props.getUserData().brokerPercent,
    };

    this.validatorTypes = function() {
      var base = Joi.object().keys({
        name: Joi.string()
          .required()
          .label("Company Name"),
        website: Joi.string()
          .regex(
            new RegExp(
              /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
            )
          )
          .label("Company Website"),
        address: Joi.string()
          .required()
          .label("Company Address"),
        zipcode: Joi.string()
          .regex(new RegExp("^[0-9]{5}(?:-[0-9]{4})?$"))
          .required(),
        city: Joi.string()
          .required()
          .label("City"),
        state: Joi.string()
          .required()
          .label("State"),
        // agentPercent: Joi.number()
        //   .min(0.001)
        //   .required()
        //   .label("agentPercent"),
        phoneNumber: Joi.string()
          .regex(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"))
          .required()
          .label("Company Phone No"),
      });
      return base;
    };

    this.getValidatorData = this.getValidatorData.bind(this);
    this.renderHelpText = this.renderHelpText.bind(this);
    this.isValidated = this.isValidated.bind(this);
  }

  /**
   * @desc get validator data
   * this object is used to perform validation based on set joi validation schema
   */
  getValidatorData() {
    return {
      name: this.props.getUserData().companyInformation.name,
      website: this.props.getUserData().companyInformation.website,
      address: this.props.getUserData().companyInformation.address,
      zipcode: this.state.zipcode,
      city: this.props.getUserData().companyInformation.city,
      state: this.props.getUserData().companyInformation.state,
      phoneNumber: this.props.getUserData().companyInformation.phoneNumber,
      // faxNumber: this.props.getUserData().companyInformation.faxNumber,
      // typeOfBusiness: this.props.getUserData().companyInformation
      //   .typeOfBusiness,
      // companySize: this.props.getUserData().companyInformation.companySize,
      // agentPercent: this.state.agentPercent,
    };
  }

  /**
   * @desc check form is validate or not
   */
  isValidated() {
    return new Promise((resolve, reject) => {
      this.props.validate((error) => {
        if (error) {
          reject();
          return false;
        }
        resolve();
        return true;
      });
    });
  }

  renderHelpText(message, id) {
    return (
      <div className="val-err-tooltip" key={id}>
        <span>{message}</span>
      </div>
    );
  }

  /**
   * @desc on change event of input tags and set data to state and also updating data in parent component
   */
  onChange(event) {
    if (event.target.name === "zipcode") {
      this.setState({ zipcode: event.target.value });
      this.props.updateUserData("zipcode", event.target.value);

      //If zipcode is changed then get city and state from entered zicode
      let enteredZip = event.target.value.toString();
      let zipcode = enteredZip.replace(/\-/g, "");

      if (
        event.target.value != "000000" &&
        (zipcode.length == 5 || zipcode.length == 9)
      ) {
        this.props.getCityState(enteredZip).then((res) => {
          this.setState({ city: res.city, state: res.state });
          this.props.updateUserData("city", res.city);
          this.props.updateUserData("state", res.state);
        });
      } else {
        this.setState({ city: "", state: "" });
        this.props.updateUserData("city", "");
        this.props.updateUserData("state", "");
      }
    } else {
      this.setState({ [event.target.name]: event.target.value });
      this.props.updateUserData(event.target.name, event.target.value);
    }
  }

  /**
   * @desc get error message for given field from errlist from validator
   */
  getErrorMsg(field, errsList) {
    var err = "";
    if (
      field === "name" ||
      field === "address" ||
      field === "city" ||
      field === "state"
      // field === "agentPercent"
    ) {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (field === "name") {
          err = message.ENTER_COMPANY_NAME;
        }
        if (field === "address") {
          err = message.ENTER_COMPANY_ADDRESS;
        }
        if (field === "city") {
          err = message.ENTER_CITY;
        }
        if (field === "state") {
          err = message.SELECT_STATE;
        }
        // if (field === "agentPercent") {
        //   err = message.ENTER_PERCENTAGE;
        // }
      }
    }
    if (field === "zipcode") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_ZIP;
        }
        if (errsList[field].length === 1) {
          err = message.ENTER_VALID_ZIP;
        }
      }
    }

    if (field === "phoneNumber") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_PHONE;
        }
        if (errsList[field].length === 1) {
          err = message.PHONE_10_DIGIT;
        }
      }
    }

    if (field === "website") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 1) {
          err = message.VALID_COMPANY_WEBSITE;
        }
        if (errsList[field].length === 2) {
          delete errsList["website"];
        }
      }
    }

    return err;
  }

  render() {
    var stateDropDownValue = [];
    for (var key in StatesList) {
      var opt = (
        <option key={key} value={key}>
          {StatesList[key]}
        </option>
      );
      stateDropDownValue.push(opt);
    }

    return (
      <div className="step-content">
        <h4 className="title-blue mb-3">Studio Information</h4>
        <Form className="form-sm">
          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>
                Studio Name<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.name}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="name"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("name")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("name", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>Studio Website</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.website}
                  onChange={this.onChange.bind(this)}
                  name="website"
                  type="text"
                  size="lg"
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("website", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>
                Studio Address<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  defaultValue={this.state.address}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="address"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("address")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("address", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>
                  Zip Code<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>

                <Form.Control
                  maxLength="14"
                  defaultValue={this.state.zipcode}
                  onChange={this.onChange.bind(this)}
                  name="zipcode"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("zipcode")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("zipcode", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>
                  City<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  value={this.state.city}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="city"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("city")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("city", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>
                  State<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <div className="c-select">
                  <select
                    name="state"
                    id=""
                    className="form-control form-control-lg"
                    value={this.state.state}
                    onChange={this.onChange.bind(this)}
                    onBlur={this.props.handleValidation("state")}
                  >
                    <option value="">Select</option>
                    {stateDropDownValue}
                  </select>
                </div>

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("state", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                Studio Phone No.<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>

                <InputMask
                  mask="999-999-9999"
                  maskChar=""
                  formControlProps={{
                    fullWidth: true,
                  }}
                  className="form-control form-control-lg"
                  value={this.state.phoneNumber}
                  name="phoneNumber"
                  onChange={this.onChange.bind(this)}
                  onBlur={this.props.handleValidation("phoneNumber")}
                >
                  {(inputProps) => <Form.Control {...inputProps} />}
                </InputMask>

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("phoneNumber", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
            {/* <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Company Fax </Form.Label>

                <InputMask
                  mask="999-999-9999"
                  maskChar=""
                  formControlProps={{
                    fullWidth: true,
                  }}
                  className="form-control form-control-lg"
                  value={this.state.faxNumber}
                  name="faxNumber"
                  onChange={this.onChange.bind(this)}
                >
                  {(inputProps) => <Form.Control {...inputProps} />}
                </InputMask>
              </Form.Group>
            </Col> */}
          </Row>

          <Row>
            {/* <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Type of Business</Form.Label>
                <div className="c-select">
                  <select
                    name="typeOfBusiness"
                    defaultValue={this.state.typeOfBusiness}
                    onChange={this.onChange.bind(this)}
                    id=""
                    className="form-control form-control-lg"
                  >
                    <option value="">Select</option>
                    <option value="Brokerage">Brokerage</option>
                  </select>
                </div>
              </Form.Group>
            </Col> */}
            {/* <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Company Size</Form.Label>
                <div className="c-select">
                  <select
                    name="companySize"
                    defaultValue={this.state.companySize}
                    onChange={this.onChange.bind(this)}
                    id=""
                    className="form-control form-control-lg"
                  >
                    <option value="">Select</option>
                    <option value="1-10">Small (1-10)</option>
                    <option value="11-24">Medium (11-24)</option>
                    <option value="24+">Large (24+)</option>
                  </select>
                </div>
              </Form.Group>
            </Col> */}
          </Row>

          {/* <h4 className="title-blue mb-2 mt-2">Commission</h4> */}
          <Row>
            {/* <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Agent % <span style={{ color: "#FFFFFF" }}>*</span>
                </Form.Label>
                <NumericInput
                  name="agentPercent"
                  precision={2}
                  min={0}
                  max={100}
                  inputMode="numeric"
                  strict
                  style={false}
                  className="form-control form-control-lg"
                  value={this.state.agentPercent}
                  onChange={(e) => {
                    this.setState({
                      agentPercent: e.toFixed(2),
                      brokerPercent: (100 - e).toFixed(2),
                    });
                    this.props.updateUserDetails("agentPercent", e.toFixed(2));
                    this.props.updateUserDetails(
                      "brokerPercent",
                      (100 - e).toFixed(2)
                    );
                  }}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("agentPercent", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col> */}
            {/* <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Brokerage %</Form.Label>
                <Form.Control
                  value={this.state.brokerPercent}
                  disabled
                  name="brokerPercent"
                  type="text"
                  size="lg"
                />
              </Form.Group>
            </Col> */}
          </Row>
        </Form>
      </div>
    );
  }
}

InviteCompanyInfo.propTypes = {
  errors: PropTypes.object,
  validate: PropTypes.func,
  isValid: PropTypes.func,
  handleValidation: PropTypes.func,
  getValidationMessages: PropTypes.func,
  clearValidations: PropTypes.func,
  getUserData: PropTypes.func,
  updateUserData: PropTypes.func,
};

export default validation(strategy)(InviteCompanyInfo);
